import React from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";
import ComposerDisplay from "../../../components/composer/composerDisplay";
import { ContributorResponseDTO } from "../../../openapi-generated-client";

export default function ComposerPieceInfoGroup(props: PieceInfoGroupProps) {

    var infos = [];

    infos.push(<div className="composer-piece-info-group" key={props.piece.composer.id}>
        <h4>{props.piece.original ? "Composer" : "Transcriptor"}</h4>
        <ComposerDisplay
            key={props.piece.composer.id}
            artist={props.piece.composer}
            confirmed={props.piece.composer.verified ? props.piece.composer.verified : false}/>
    </div>);

    if(!props.piece.original) {
        infos.push(<div className="composer-piece-info-group" key={props.piece.transcriptionInfo.originalComposer.id}>
            <h4>Original Composer</h4>
            <ComposerDisplay
                    key={props.piece.transcriptionInfo.originalComposer.id}
                    artist={props.piece.transcriptionInfo.originalComposer}
                confirmed={false}/>
        </div>);
    }

    if(props.piece.contributors.length > 0) {
        infos.push(<h4>Contributors</h4>);

        props.piece.contributors.forEach((contributor: ContributorResponseDTO) => {
            infos.push(<div className="composer-piece-info-group" key={contributor.id}>
                <span>{contributor.type}</span>
                <ComposerDisplay
                    key={contributor.id}
                    artist={contributor.artist}
                    confirmed={false}/>
            </div>);
        });
    }

    return <>
    {infos}
    </>;
}